import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const IMG = "https://images.unsplash.com/photo-1598737285721-29346a5c9278?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxzdXBlcnlhY2h0JTIwb2NlYW58ZW58MHx8fHwxNzg1OTE5MDI3fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bienvenido de nuevo");
      navigate(u.role === "admin" ? "/admin" : u.role === "partner" ? "/partner" : "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-b border-white/20 py-4 text-white placeholder-white/30 font-light focus:border-gold focus:outline-none transition-colors";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#050505] text-white">
      <div className="relative hidden lg:block">
        <img src={IMG} alt="Lujo" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-black/40" />
        <div className="absolute bottom-16 left-12">
          <span className="font-serif-display text-3xl">Sol<span className="text-gold">Club</span></span>
          <p className="text-white/60 font-light mt-3 max-w-xs">El mundo, sin fricción.</p>
        </div>
      </div>

      <div className="flex flex-col justify-center px-8 lg:px-24 py-16">
        <Link to="/" className="flex items-center gap-2 text-white/50 hover:text-gold text-xs tracking-luxe-sm uppercase mb-16" data-testid="back-home">
          <ArrowLeft size={16} strokeWidth={1.5} /> Inicio
        </Link>
        <p className="text-xs tracking-luxe uppercase text-gold mb-4">Acceso de Miembros</p>
        <h1 className="font-serif-display text-4xl md:text-5xl mb-12">Acceder</h1>
        <form onSubmit={submit} className="space-y-8 max-w-sm" data-testid="login-form">
          <input required type="email" data-testid="login-email" className={field} placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required type="password" data-testid="login-password" className={field} placeholder="Contraseña"
            value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-gold text-black py-4 text-xs tracking-luxe uppercase hover:bg-[#C5A059] transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
            {loading && <Loader2 size={16} className="animate-spin" />} Entrar
          </button>
        </form>
        <p className="text-white/50 font-light text-sm mt-10">
          ¿No tiene cuenta?{" "}
          <Link to="/register" className="text-gold gold-underline" data-testid="go-register">Alta Nuevo Socio</Link>
        </p>
      </div>
    </div>
  );
}
